module.exports = __webpack_public_path__ + "img/Themes.62ab4905.png";